package space.stanton.pages.posts

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBp_2025_08_25_a_few_useful_bash_commandsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("posts/bp_2025_08_25_a_few_useful_bash_commands.md", FrontMatterElement.Builder { addScalar("title", "A few useful bash commands"); addScalar("type", "blogpost"); addScalar("date", "2025_08_25"); }))
}

@Page("/posts/bp-2025-08-25-a-few-useful-bash-commands")
@Composable
fun Bp_2025_08_25_a_few_useful_bash_commandsPage() {
    space.stanton.components.layouts.BlogPost {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("A handful of helpful commands I've found for shell operations (works with Bash or Zsh).")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("du -sh .")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Print how much memory the current folder (and everything within it) is taking up on disk.")
            }
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("du")
                }
                org.jetbrains.compose.web.dom.Text(" stands for ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("d")
                }
                org.jetbrains.compose.web.dom.Text("isk ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("u")
                }
                org.jetbrains.compose.web.dom.Text("sage, ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("-sh")
                }
                org.jetbrains.compose.web.dom.Text(" asks for the info to be ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("s")
                }
                org.jetbrains.compose.web.dom.Text("ummarised in a ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("h")
                }
                org.jetbrains.compose.web.dom.Text("uman readable format.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("output examples: ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("178M    .")
                }
                org.jetbrains.compose.web.dom.Text(" or ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("1.2G   .")
                }
                org.jetbrains.compose.web.dom.Text(" (178 megabytes and 1.36 Gigabytes respectively)")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("lsof -i:8080")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("List the processes (or files) running on port 8080")
            }
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("lsof")
                }
                org.jetbrains.compose.web.dom.Text(" stands for ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("l")
                }
                org.jetbrains.compose.web.dom.Text("i")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("s")
                }
                org.jetbrains.compose.web.dom.Text("t ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("o")
                }
                org.jetbrains.compose.web.dom.Text("pen ")
                com.varabyte.kobweb.compose.dom.GenericTag("ins", null) {
                    org.jetbrains.compose.web.dom.Text("f")
                }
                org.jetbrains.compose.web.dom.Text("iles")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("In posix systems all processes are considered files, so this works for e.g. server processes etc.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("The output will give you the PID (process ID) of the process")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("If you then want to kill the process you can enter ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("kill <insert PID here>")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("find . -name *.kt")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Search current folder (recursively) for all files with a given filename ending (in this case .kt)")
            }
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("find")
                }
                org.jetbrains.compose.web.dom.Text(" is a tool for working with file hierarchies")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("This will give you a list of the relative paths of the files from the current directory.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("The ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("*")
                }
                org.jetbrains.compose.web.dom.Text(" is a wildcard character matching all text before ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text(".kt")
                }
            }
        }
    }
}
